import styled from 'styled-components';

import { absoluteDivStyles } from '../styles';

export const CountryContentWrapper = styled.div`
  ${absoluteDivStyles}

  padding: 8px;
`;
